/** Where the lap was fastest and slowest: the markers on the speed trace and
 *  the race-line map. Taken from the raw ticks, not a resampled series. */

import { required } from './columns';
import { at, maxOf, minOf } from './interp';
import type { PeaksValleys, Samples, SpeedPoint } from './types';

/** Local speed maxima/minima along the lap, thinned to one per minGapM. */
export function speedPeaksValleys(samples: Samples, minGapM = 100): PeaksValleys {
  const dist = required(samples, 'dist');
  const speed = required(samples, 'speed');
  const xs = required(samples, 'pos_x');
  const zs = required(samples, 'pos_z');
  const peaks: SpeedPoint[] = [];
  const valleys: SpeedPoint[] = [];
  const w = 30; // ticks (~0.5 s) on each side
  let i = w;
  while (i < speed.length - w) {
    const v = speed[i]!;
    const point: SpeedPoint = { dist: at(dist, i), speed: v, x: at(xs, i), z: at(zs, i) };
    if (v >= maxOf(speed, i - w, i + w + 1)) {
      const last = peaks[peaks.length - 1];
      if (last === undefined || point.dist - last.dist > minGapM) peaks.push(point);
      i += w;
    } else if (v <= minOf(speed, i - w, i + w + 1)) {
      const last = valleys[valleys.length - 1];
      if (last === undefined || point.dist - last.dist > minGapM) valleys.push(point);
      i += w;
    }
    i += 1;
  }
  return { peaks, valleys };
}
